import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserRecipientViewModel } from '../../../business-entities/user-recipient-list-view.model';
import { MechanicService } from '../../../business-services/mechanic.service';

@Component({
  selector: 'app-mechanic-recipient-list',
  templateUrl: './mechanic-recipient-list.component.html'
})
export class MechanicRecipientListComponent implements OnInit {

  list: UserRecipientViewModel[];
  id:number;

  constructor(
    private service: MechanicService,
   private spinner: NgxSpinnerService,private activeModal : NgbActiveModal ) {

  }

  ngOnInit(): void {
    this.id=this.service.mechanicId;
    this.getList();
  }

  async getList() {
    this.spinner.show();
    await this.service.gtRecipientList(this.id).then((response) => {
      this.list = response.responseObject;
      this.spinner.hide();
    },_error => {
      this.spinner.hide()
    });

  }
  OnClose(){
    this.activeModal.close({ success: true });
  }

}
